import * as React from 'react';
import PropTypes from 'prop-types';

const SvgSportsSurfingNormalXsmall = React.forwardRef(
  ({ color, size, title, titleId, ...props }, ref) => (
    <svg
      fill={color}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 16 16"
      ref={ref}
      width={size}
      height={size}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <path
        d="M5.433 6.142c-2.343 4.405-2.482 6.736-2.486 6.834l-.026.524h2.16l1.21 1.794.424-.332c.075-.06 1.869-1.5 4.208-5.9 2.418-4.547 1.7-7.272 1.264-8.25L12 .446l-.4.069C10.549.7 7.84 1.611 5.433 6.142zm4.607 2.45A23.162 23.162 0 016.49 13.8l-.564-.836 5.643-10.608c.166 1.214.045 3.277-1.53 6.236zm.66-6.727L5.04 12.5H4.023a21.7 21.7 0 012.293-5.889C7.885 3.657 9.562 2.4 10.7 1.865z"
        fill=""
      />
    </svg>
  )
);
SvgSportsSurfingNormalXsmall.defaultProps = {
  color: 'currentColor',
  size: 16,
  title: undefined,
  titleId: undefined
};
SvgSportsSurfingNormalXsmall.propTypes = {
  color: PropTypes.string,
  size: PropTypes.number,
  title: PropTypes.string,
  titleId: PropTypes.string
};
export default SvgSportsSurfingNormalXsmall;
